import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from './forms/GenericFormHeaderComponent';
import NoDataFound from './NoDataFound';

const AppliedFiltersSidebarModal = (props) => {

    const { filter_condition = "", sqs_body = "" } = props.selectedData;

    const filterData = JSON.parse(filter_condition);
    const exportedData = JSON.parse(sqs_body)

    const [headersData, setHeadersData] = useState(exportedData?.request?.headers || {})

    const getChipColor = {
        'pending': 'bg-[#FFB142]',
        'success': 'bg-[#03B675]',
        'error': 'bg-[#FD3757]'
    }

    const getChipBorderColor = {
        'pending': 'border border-[#FFB142]',
        'success': 'border border-[#03B675]',
        'error': 'border border-[#FD3757]'
    }

    const renderRow = (key, value) => {
        let getType = typeof value;
        switch (getType) {
            case "string":
                if(value?.includes(',')) {
                    let newVal = value?.split(',');
                    return <div className='space-y-1'>
                        <h3 className='mb-0 text-[#4A5D7A] text-[11px] font-normal'>{headersData?.[key] || key}</h3>
                        {newVal?.map((item) => <div className={`inline-block mr-2 w-fit text-fontBlack text-[13px] font-medium border border-[#F0F2F5] bg-[#F8F8FB] py-0 px-2 mt-[0] ml-[0]`}>{item || '-'}</div>)}
                    </div>
                }
                else return <div className='space-y-1'>
                    <h3 className='mb-0 text-[#4A5D7A] text-[11px] font-normal'>{headersData?.[key] || key}</h3>
                    <div className={`w-fit text-fontBlack text-[13px] font-medium border border-[#F0F2F5] bg-[#F8F8FB] py-0 px-2 mt-[0] ml-[0]`}>{value || '-'}</div>
                </div>
            case "object":
                return <div className='space-y-1'>
                    <h3 className='mb-0 text-[#4A5D7A] text-[11px] font-normal'>{headersData?.[key] || key}</h3>
                    <div className={`w-fit text-fontBlack text-[13px] font-medium border border-[#F0F2F5] bg-[#F8F8FB] py-0 px-2 mt-[0] ml-[0]`}>{value?.from} to {value?.to}</div>
                </div>
            default: return <div className='space-y-1'>
                <h3 className='mb-0 text-[#4A5D7A] text-[11px] font-normal'>{headersData?.[key] || key}</h3>
                <div className={`w-fit text-fontBlack text-[13px] font-medium border border-[#F0F2F5] bg-[#F8F8FB] py-0 px-2 mt-[0] ml-[0]`}>{value[key] || '-'}</div>
            </div>
        }
    }

    const renderBody = () => {
        if (!filterData) {
            return <div className='p-[15px] h-full flex justify-center items-center'>
                <NoDataFound />
            </div>
        }

        return <div className='p-[15px] h-full overflow-auto space-y-4'>
            {Object.keys(filterData || {})?.map(key => {
                if (key === "item") {
                    return Object.keys(filterData?.[key] || {})?.map((innerKey) => {
                        return renderRow(innerKey, filterData?.[key]?.[innerKey])
                    })
                }
                else return renderRow(key, filterData?.[key])
            })}
        </div>

    }

    return (
        <div className='h-full flex flex-col'>
            <GenericFormHeaderComponent
                label={{
                    contentPrimary: 'Filters Applied',
                    contentSecondry: 'Please find below the list of filters and values to help let you know more filters applied on respective Data.'
                }}
                headerClassName="border-b border-borderSlateGray"
            />
            {/* <div className='p-[15px] h-full'> */}
            {renderBody()}
            {/* </div> */}
        </div>
    )
}

export default AppliedFiltersSidebarModal